import React from 'react';

import { currentWinner, initialSets, useMatchScoreDraft } from './scoring-match-draft';
import ScoringMatchForm from './scoring-match-form';
import ScoringMatchSides from './scoring-match-sides';
import type { MatchItem, ScoringSystem } from './scoring-types';

interface Props {
  match: MatchItem;
  token: string;
  canSubmit: boolean;
  scoring?: ScoringSystem;
  isOpen: boolean;
  onToggle: () => void;
  onSaved: () => void;
}

export const ScoringMatchCard: React.FC<Props> = ({
  match,
  token,
  canSubmit,
  scoring,
  isOpen,
  onToggle,
  onSaved,
}) => {
  const draft = useMatchScoreDraft(match, token, onSaved);

  const expanded = canSubmit && isOpen;
  const savedWinner = currentWinner(match);
  const shownWinner = expanded ? draft.winner : savedWinner;
  const shownSets = expanded ? draft.sets : initialSets(match);

  function handleCancel(): void {
    draft.reset();
    onToggle();
  }

  return (
    <li data-testid={`scoring-match-${match.id}`} className="scoring-match-card">
      <div
        className="scoring-match-header"
        role={canSubmit ? 'button' : undefined}
        onClick={canSubmit ? onToggle : undefined}
      >
        <ScoringMatchSides match={match} sets={shownSets} winner={shownWinner} scoring={scoring} />
        <div className="scoring-match-meta">
          {savedWinner === null ? (
            <span data-testid={`match-${match.id}-planned`} className="scoring-match__pending">
              {expanded ? '' : canSubmit ? 'Wpisz wynik' : 'Brak wyniku'}
            </span>
          ) : (
            <span data-testid={`match-${match.id}-result`} className="scoring-match-result">
              ✓
            </span>
          )}
          {canSubmit && <span className="scoring-match-toggle">{expanded ? '▲' : '▼'}</span>}
        </div>
      </div>

      {expanded && (
        <ScoringMatchForm match={match} draft={draft} cancelLabel="Anuluj" onCancel={handleCancel} />
      )}
    </li>
  );
};

export default ScoringMatchCard;
